export default "__VITE_ASSET__Bvw8NfKH__"